<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
  >
    <template slot="header">
      <span
        v-if="item"
        style="font-size: 30px; font-weight: 500; color: #000000;"
      >Job: {{ item.wo_number }} - {{ item.project }}; {{ item.project_floor }}</span>
      <v-col class="text-end">
        <span style="font-size: 30px; font-weight: 500; color: #000000;">Total Items: {{ items.length }}</span>
      </v-col>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              :items-per-page="-1"
              :loading="loading"
              dense
            >
              <template #[`item.ext_color`]="{ item }">
                <span>
                  {{ item.ext_color ? `${item.ext_color.code} - ${item.ext_color.name}` : '' }}
                </span>
              </template>
              <template #[`item.int_color`]="{ item }">
                <span>
                  {{ item.int_color ? `${item.int_color.code} - ${item.int_color.name}` : '' }}
                </span>
              </template>
              <template #[`item.quantity`]="{ item }">
                <span>
                  {{ item.quantity ? item.quantity : '-' }}
                </span>
              </template>
              <template #[`item.cut_height`]="{ item }">
                <span>
                  {{ item.cut_height ? item.cut_height : '-' }}
                </span>
              </template>
              <template #[`item.location`]="{ item }">
                <span>
                  {{ item.location ? item.location.name : '' }}
                </span>
              </template>
              <template #[`item.inventory_location`]="{ item }">
                <span>
                  {{ item.inventory_location ? item.inventory_location.name : '' }}
                </span>
              </template>
              <template #[`item.status`]="{ item }">
                <v-tooltip
                  bottom
                  color="black"
                >
                  <template #activator="{ on }">
                    <v-chip
                      v-if="item && item.status"
                      small
                      :color="item.status.color ? item.status.color : '#000000'"
                      text-color="white"
                      @mouseover="getHistory(item)"
                      v-on="on"
                    >
                      {{ item.status.name }}
                    </v-chip>
                  </template>

                  <div
                    style="width: 400px; flex-direction: column; gap: 12px;"
                    class="pt-3 d-flex"
                  >
                    <div
                      v-for="history in finishedGoodHistories"
                      :key="history.id"
                      class="d-flex align-center"
                    >
                      <div style="width: 50%">
                        <v-chip
                          v-if="history && history.status"
                          small
                          :color="history.status.color ? history.status.color : '#000000'"
                          text-color="white"
                        >
                          {{ history.status.name }}
                        </v-chip>
                      </div>
                      <span> At: {{ history.created_at }}</span>
                    </div>
                  </div>
                </v-tooltip>
              </template>
              <template #[`item.department`]="{ item }">
                <span>
                  {{ item.department ? item.department.name : '' }}
                </span>
              </template>
              <template #[`item.quarantine_remake_reason`]="{ item }">
                <span>
                  {{ item.quarantine_reason ? item.quarantine_reason.name : '' }} - {{ item.quarantine_sub_reason ? item.quarantine_sub_reason.name : '' }}; {{ item.quarantined_at ? item.quarantined_at : '' }}
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
  },
  props: {

  },
  data: () => ({
    items: [],
    loading: false,
    item: null,
    noteTypeIdFinishedGood: 3,
    finishedGoodStatusIdReturned: 12,
    finishedGoodStatusIdQuarantined: 13,
    statusIdFinishedGoods: 8,
    statusId: null,
    finishedGoodHistories: [],
    loadingHistory: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
    headers() {
      const returnHeaders = [];
      returnHeaders.push({ text: 'Serial#', value: 'index' });
      returnHeaders.push({ text: 'Tag Id', value: 'tag_id' });
      returnHeaders.push({ text: 'Tag Number', value: 'tag_number' });
      returnHeaders.push({ text: 'Work Order', value: 'work_order' });
      returnHeaders.push({ text: 'Quantity', value: 'quantity' });
      returnHeaders.push({ text: 'Aluminum Die Code', value: 'aluminum_die_code' });
      returnHeaders.push({ text: 'External Color', value: 'ext_color' });
      returnHeaders.push({ text: 'Internal Color', value: 'int_color' });
      returnHeaders.push({ text: 'Width', value: 'cut_width' });
      returnHeaders.push({ text: 'Height', value: 'cut_height' });
      returnHeaders.push({ text: 'Sqft', value: 'sqft' });

      if (this.statusId > this.statusIdFinishedGoods) {
        returnHeaders.push({ text: 'Location', value: 'location' });
        returnHeaders.push({ text: 'Shelf', value: 'inventory_location' });
      }

      if (this.statusId === this.finishedGoodStatusIdReturned) {
        returnHeaders.push({
          text: 'Return Reason', value: 'return_reason',
        });
      }

      if (this.statusId === this.finishedGoodStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Department', value: 'department',
        });
      }
      if (this.statusId === this.finishedGoodStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Quarantine Reasons', value: 'quarantine_remake_reason',
        });
      }

      returnHeaders.push({ text: 'Status', value: 'status', align: 'center' });

      return returnHeaders;
    },
  },
  watch: {

  },
  created() {
  },
  methods: {

    async get(item, statusId) {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          screen_schedule_id: item.id,
          status_id: statusId,
        },
      };
      const res = await this.$api.screen.read(submitModel);
      this.loading = false;
      if (!res) return;
      this.items = res;
    },

    async getHistory(item) {
      if (this.loadingHistory) return;
      this.loadingHistory = true;
      const submitModel = {
        filters: {
          screen_id: item.id,
        },
      };

      const res = await this.$api.screenHistory.read(submitModel);

      this.loadingHistory = false;
      if (!res || !res.data || res.data.length === 0) {
        this.finishedGoodHistories = [];
        return;
      }

      this.finishedGoodHistories = res.data;
    },

    open(item, statusId) {
      this.item = item;
      this.statusId = statusId;
      this.get(item, statusId);
      this.$refs.dialogBox.open();
    },

    openNoteForm(itemId) {
      this.$refs.noteForm.open(itemId, this.noteTypeIdFinishedGood);
    },
  },
};
</script>
